import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import Loading from 'apa/components/Loading';
import {ListGroup} from 'reactstrap';
import {Template} from 'template/components/Template';
import TemplateCategoryEdit from 'template/components/TemplateCategoryEdit';

@connect(
    state => ({
        templateList: state.template.templateList,
        isLoading: state.template.isLoading
    }),
    {}
)
export default class TemplateList extends Component {
    render() {
        const {
            isLoading,
            templateList
        } = this.props;
        if (isLoading)
            return <Loading/>
        return (
            <Fragment>
                <TemplateCategoryEdit />
                <ListGroup>
                    {
                        templateList.map(
                            (template, index) => (<Template
                                key={`template_${template.id}`}
                                index={index + 1}
                                template={template}/>)
                        )
                    }
                </ListGroup>
            </Fragment>
        )
    }
}
